/*
 * V01 UI behaviors — vanilla JS replacement.
 * Removed: 200+ lines of jQuery + OwlCarousel + Slick init code (libraries gone).
 * Keeps only: mobile hamburger toggle, V01 dropdown toggle, search modal trigger.
 * No dependencies. ~1.5 KB.
 */

document.addEventListener('DOMContentLoaded', function () {

  /* Mobile hamburger toggle */
  document.querySelectorAll('.mob-hamburger button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.classList.toggle('active');
      document.querySelectorAll('.header-angle, .header-pages ul').forEach(function (el) {
        el.classList.toggle('active');
      });
    });
  });

  /* V01 dropdown toggle */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('.dropdown .dropdown-button .r-arrow1');
    if (arrow) {
      var dropdown = arrow.closest('.dropdown');
      if (dropdown && dropdown.querySelectorAll('.dropdown-content a').length > 0) {
        dropdown.classList.toggle('active');
      }
    }
  });

  /* Search icon opens details-modal */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('form.search-form.search-page-form, .s-icon');
    if (trigger) {
      var headerSearch = trigger.closest('.header-search');
      if (!headerSearch) return;
      var details = headerSearch.querySelector('details-modal.header__search details');
      if (details) {
        details.open = true;
        document.body.style.overflow = 'hidden';
        var input = trigger.querySelector('input');
        if (input) input.disabled = true;
      }
    }
    var overlay = e.target.closest('details[open] .modal-overlay');
    if (overlay) {
      var headerSearch2 = overlay.closest('.header-search');
      if (headerSearch2) {
        var details2 = headerSearch2.querySelector('details-modal.header__search details');
        if (details2) details2.open = false;
        setTimeout(function () {
          document.body.style.overflow = '';
          var input = document.querySelector('form.search-form.search-page-form input');
          if (input) input.disabled = false;
        }, 200);
      }
    }
  });

  /* OwlCarousel/Slick init REMOVED — libraries gone. CSS scroll-snap handles horizontal scrolling. */
});

/* Category tile row — inject prev/next arrow buttons, scroll programmatically */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.headder-products').forEach(function (wrap) {
    var row = wrap.querySelector('.headder-products-flex');
    if (!row) return;
    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'ht-scroll-btn ht-prev';
    prev.setAttribute('aria-label', 'Scroll categories left');
    prev.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6z"/></svg>';
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'ht-scroll-btn ht-next';
    next.setAttribute('aria-label', 'Scroll categories right');
    next.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"/></svg>';
    (wrap.querySelector('.container') || wrap).appendChild(prev);
    (wrap.querySelector('.container') || wrap).appendChild(next);

    function step() {
      var firstTile = row.querySelector('.headder-products-sub');
      var w = firstTile ? firstTile.getBoundingClientRect().width + 18 : 130;
      return Math.max(w * 3, 200);
    }
    prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });

    function updateBtns() {
      var atStart = row.scrollLeft <= 4;
      var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
      prev.hidden = atStart;
      next.hidden = atEnd;
    }
    row.addEventListener('scroll', updateBtns, { passive: true });
    window.addEventListener('resize', updateBtns);
    setTimeout(updateBtns, 100);
  });
});
